export default __webpack_public_path__ + "0bc6e781b3364e704e62e901f16d6d60.png";